/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_sidebar_organization_fallback = /** @type {(inputs: {}) => string} */ () => {
	return `Organización`
};

const en_sidebar_organization_fallback = /** @type {(inputs: {}) => string} */ () => {
	return `Organization`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sidebar_organization_fallback = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sidebar_organization_fallback(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sidebar_organization_fallback", locale)
	if (locale === "es") return es_sidebar_organization_fallback(inputs)
	return en_sidebar_organization_fallback(inputs)
};
export { sidebar_organization_fallback as "sidebar.organization_fallback" }